module.exports = __webpack_public_path__ + "static/media/revisiones.65651d60.png";